export default __webpack_public_path__ + "static/client-799820d3f61330950bd947906a0724d2.webp";